import React from 'react';

export default function HeatExchanger10Icon({
  width = 64,
  height = 67,
  startColor = '#4C4C4C',
  midColor = '#E5E5E5',
  endColor = '#4C4C4C'
}) {
  const id = Math.random().toString(36).slice(2, 9);
  return (
    <svg width={width} height={height} viewBox="0 0 107.992 112.5" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter id={`fp-shadow-${id}`} x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="2.5"/>
          <feOffset dx="0" dy="3" result="offsetblur"/>
          <feComponentTransfer><feFuncA type="linear" slope="0.45"/></feComponentTransfer>
          <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
        <radialGradient id={`fp-shine-${id}`} cx="35%" cy="22%" r="65%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.28)"/>
          <stop offset="55%" stopColor="rgba(255,255,255,0.06)"/>
          <stop offset="100%" stopColor="rgba(255,255,255,0)"/>
        </radialGradient>
      </defs>
      <g filter={`url(#fp-shadow-${id})`}>
      <g id="Group_Bottom_Layer">
	
		<radialGradient id={`${id}_1_`} cx="53.9402" cy="102.9268" r="38.3424" gradientTransform="matrix(1 0 0 0.3 0 72.0487)" gradientUnits="userSpaceOnUse">
		<stop offset="0" style={{stopColor: "#B4B4B4"}} />
		<stop offset="1" style={{stopColor: "#7F7F7F"}} />
	</radialGradient>
	<ellipse fill={`url(#${id}_1_)`} stroke="#4C4C4C" strokeWidth="0.25" cx="53.94" cy="102.927" rx="53.49" ry="8.896" />
</g>
<g id="Group_Middle_Discs">
	
		<radialGradient id={`${id}_2_`} cx="53.0667" cy="96.3477" r="38.3427" gradientTransform="matrix(0.9925 -0.1219 0.0366 0.2978 -3.127 74.126)" gradientUnits="userSpaceOnUse">
		<stop offset="0" style={{stopColor: "#E5E5E5"}} />
		<stop offset="1" style={{stopColor: "#999999"}} />
	</radialGradient>
	<path fill={`url(#${id}_2_)`} stroke="#4C4C4C" strokeWidth="0.1" d="M8.456,98.917c-1.328,0.442-2.656,0.102-3.897-0.156   c-3.078,1.553-4.719,3.057-4.547,4.4c0.626,4.873,24.886,5.773,54.187,2.01c29.301-3.762,52.547-10.762,51.921-15.636   c-0.626-4.873-24.886-5.773-54.188-2.011c-0.16,0.021-0.318,0.042-0.477,0.063c0,2.443,0,4.886,0,7.328" />
	
		<radialGradient id={`${id}_3_`} cx="53.0667" cy="82.6816" r="38.3427" gradientTransform="matrix(0.9925 -0.1219 0.0366 0.2978 -2.6273 64.5292)" gradientUnits="userSpaceOnUse">
		<stop offset="0" style={{stopColor: "#E5E5E5"}} />
		<stop offset="1" style={{stopColor: "#999999"}} />
	</radialGradient>
	<path fill={`url(#${id}_3_)`} stroke="#4C4C4C" strokeWidth="0.1" d="M8.456,85.251c-1.328,0.442-2.656,0.102-3.897-0.156   c-3.078,1.553-4.719,3.057-4.547,4.4c0.626,4.873,24.886,5.773,54.187,2.01c29.301-3.762,52.547-10.762,51.921-15.636   c-0.626-4.873-24.886-5.773-54.188-2.011c-0.16,0.021-0.318,0.042-0.477,0.063c0,2.443,0,4.886,0,7.328" />
	
		<radialGradient id={`${id}_4_`} cx="53.0676" cy="69.0156" r="38.3426" gradientTransform="matrix(0.9925 -0.1219 0.0366 0.2978 -2.1277 54.9326)" gradientUnits="userSpaceOnUse">
		<stop offset="0" style={{stopColor: "#E5E5E5"}} />
		<stop offset="1" style={{stopColor: "#999999"}} />
	</radialGradient>
	<path fill={`url(#${id}_4_)`} stroke="#4C4C4C" strokeWidth="0.1" d="M8.457,71.584c-1.328,0.443-2.656,0.102-3.897-0.156   c-3.078,1.553-4.719,3.057-4.547,4.4c0.626,4.873,24.886,5.773,54.187,2.01c29.301-3.762,52.546-10.762,51.921-15.635   c-0.627-4.873-24.886-5.774-54.188-2.012c-0.16,0.021-0.318,0.043-0.477,0.063c0,2.443,0,4.886,0,7.329" />
	
		<radialGradient id={`${id}_5_`} cx="53.0667" cy="55.6821" r="38.3427" gradientTransform="matrix(0.9925 -0.1219 0.0366 0.2978 -1.6402 45.5692)" gradientUnits="userSpaceOnUse">
		<stop offset="0" style={{stopColor: "#E5E5E5"}} />
		<stop offset="1" style={{stopColor: "#999999"}} />
	</radialGradient>
	<path fill={`url(#${id}_5_)`} stroke="#4C4C4C" strokeWidth="0.1" d="M8.456,58.251c-1.328,0.442-2.656,0.102-3.897-0.156   c-3.078,1.553-4.719,3.057-4.547,4.4c0.626,4.873,24.886,5.773,54.187,2.01C83.5,60.743,106.746,53.743,106.12,48.87   c-0.626-4.873-24.886-5.774-54.188-2.011c-0.16,0.021-0.318,0.042-0.477,0.063c0,2.443,0,4.886,0,7.329" />
	
		<radialGradient id={`${id}_6_`} cx="53.0657" cy="43.0151" r="38.3427" gradientTransform="matrix(0.9925 -0.1219 0.0366 0.2978 -1.1771 36.6739)" gradientUnits="userSpaceOnUse">
		<stop offset="0" style={{stopColor: "#E5E5E5"}} />
		<stop offset="1" style={{stopColor: "#999999"}} />
	</radialGradient>
	<path fill={`url(#${id}_6_)`} stroke="#4C4C4C" strokeWidth="0.1" d="M8.456,45.584c-1.328,0.442-2.656,0.102-3.897-0.156   c-3.078,1.553-4.719,3.057-4.547,4.4c0.626,4.873,24.886,5.773,54.187,2.01c29.301-3.762,52.547-10.762,51.92-15.635   c-0.625-4.873-24.885-5.774-54.187-2.011c-0.16,0.021-0.318,0.042-0.477,0.063c0,2.443,0,4.886,0,7.329" />
	
		<radialGradient id={`${id}_7_`} cx="53.0676" cy="29.3486" r="38.3427" gradientTransform="matrix(0.9925 -0.1219 0.0366 0.2978 -0.6775 27.077)" gradientUnits="userSpaceOnUse">
		<stop offset="0" style={{stopColor: "#E5E5E5"}} />
		<stop offset="1" style={{stopColor: "#999999"}} />
	</radialGradient>
	<path fill={`url(#${id}_7_)`} stroke="#4C4C4C" strokeWidth="0.1" d="M8.457,31.917c-1.328,0.442-2.656,0.102-3.897-0.156   c-3.078,1.553-4.719,3.057-4.547,4.4c0.626,4.873,24.886,5.773,54.187,2.01c29.301-3.762,52.546-10.762,51.921-15.635   c-0.627-4.873-24.886-5.774-54.188-2.011c-0.16,0.021-0.318,0.042-0.477,0.063c0,2.443,0,4.886,0,7.329" />
	
		<radialGradient id={`${id}_8_`} cx="53.0667" cy="16.0151" r="38.3427" gradientTransform="matrix(0.9925 -0.1219 0.0366 0.2978 -0.19 17.7136)" gradientUnits="userSpaceOnUse">
		<stop offset="0" style={{stopColor: "#E5E5E5"}} />
		<stop offset="1" style={{stopColor: "#999999"}} />
	</radialGradient>
	<path fill={`url(#${id}_8_)`} stroke="#4C4C4C" strokeWidth="0.1" d="M8.457,18.584c-1.328,0.442-2.656,0.102-3.897-0.156   c-3.078,1.553-4.719,3.057-4.547,4.4c0.626,4.873,24.886,5.773,54.187,2.01c29.302-3.762,52.548-10.762,51.921-15.635   c-0.625-4.873-24.885-5.774-54.188-2.011c-0.16,0.021-0.318,0.042-0.477,0.063c0,2.443,0,4.886,0,7.329" />
</g>
<g id="Group_Top_Layer">
	
		<radialGradient id={`${id}_9_`} cx="53.9402" cy="9.3477" r="38.3425" gradientTransform="matrix(1 0 0 0.3 0 6.5434)" gradientUnits="userSpaceOnUse">
		<stop offset="0" style={{stopColor: "#E5E5E5"}} />
		<stop offset="1" style={{stopColor: "#BDBDBD"}} />
	</radialGradient>
	<ellipse fill={`url(#${id}_9_)`} stroke="#4C4C4C" strokeWidth="0.1" cx="53.94" cy="9.348" rx="53.49" ry="8.896" />
</g>
    
      </g>
      <rect x="0" y="0" width="107.992" height="112.5" fill={`url(#fp-shine-${id})`} style={{pointerEvents:"none"}}/>
    </svg>
  );
}
